import catchify from 'catchify';
import { ATTRIBUTES_URL } from '@/constants/api';

export const getAttributes = async ($cachios, userId = 'a') => {
  const [err, attributes] = await catchify($cachios.get(`${ATTRIBUTES_URL}/?__cache=${userId}`));

  if (err || !attributes || !attributes.data) {
    return [];
  }

  return attributes.data;
};

export const checkDependency = (dependency, values) => {
  if (!dependency || Object.keys(dependency).length === 0) return true;

  const deps = Object.keys(dependency).filter((key) => {
    const required = dependency[key];
    const value = values[key];

    if (typeof value === 'undefined') return false;

    // an empty array means we just need any value to be set
    if (required.length === 0 || (required.length === 1 && required[0] === '')) {
      if (key in values) return true;
      return false;
    }
    if (!required.includes(value)) return false;

    return true;
  });

  return (deps.length === Object.keys(dependency).length);
};

export const findAttributeOption = (attributes, slug, value, values = undefined) => {
  const attrib = attributes.find((a) => a.slug === slug);

  if (attrib) {
    const options = attrib.type_options.options.filter((o) => o.value === value);
    const option = options.find((o) => {
      if (o && o.dependency && values && !checkDependency(o.dependency, values)) {
        return false;
      }

      return true;
    });

    return option;
  }

  return null;
};

export const filterAttributeDependencies = (attributes, values) => {
  const newValues = {};

  Object.keys(values).forEach((key) => {
    const value = values[key];
    const attribute = attributes.find((a) => a.slug === key);

    newValues[key] = value;

    if (attribute) {
      if (!checkDependency(attribute.dependency, values)) {
        delete newValues[key];
      } else if (attribute.type === 'enumeration') {
        let options = attribute.type_options.options.filter((o) => {
          if (Array.isArray(value)) {
            return value.includes(o.value);
          }
          return o.value === value;
        });

        if (options) {
          options = options.filter((option) => checkDependency(option.dependency, values));
          if (options.length === 0) {
            delete newValues[key];
          }
        }
      }
    }
  });

  return newValues;
};

export default {
  getAttributes,
  checkDependency,
  filterAttributeDependencies,
};
